import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-container-manager-login',
  standalone: true,
  imports: [CommonModule, PanelModule],
  templateUrl: './container-manager-login.component.html',
  styleUrls: ['./container-manager-login.component.scss'],
})
export class ContainerManagerLoginComponent {
  @Input() title = 'Acessar a Chronos';

  urlLogo = environment.configuracaoThema.logoLogin;
  urlSite = environment.configuracaoThema.site;
}
